import { createSelector } from '@ngrx/store';
import { getHistoryOrderTypeGroup } from '../getHistoryOrderTypeGroup';

export const isHistoryOrderDineIn = (orderId: number) =>
    createSelector(
        getHistoryOrderTypeGroup(orderId), (type) => type === OLO.Enums.COLLECTION_TYPE.DINE_IN
    );
